import { createEventFactory, createName } from '@cp/shared/tracking';
import { CAREER_ID_TO_CAREER_NAME } from 'src/shared/tracking';

export const VacancyEvents = {
  VacancyPublish: createEventFactory<Record<string, string>, number>(
    {
      name: createName('vacancy', 'publish', 'submit'),
      goalId: 'nazhatie_knopki_opublikovat_obyavlenie',
      goalName: 'Нажатие кнопки "Опубликовать" объявление',
    },
    (careerId) => ({
      'категория': CAREER_ID_TO_CAREER_NAME[careerId],
    }),
  ),

  VacancyCreate: createEventFactory({
    name: createName('vacancy', 'create', 'click'),
    goalName: 'Нажатие на кнопку "Добавить объявление" в объявлениях',
    goalId: 'nazhatie_na_knopku_dobavit_ob"yavlenie_v_ob"yavleniyah',
  }),

  VacancyDateSelect: createEventFactory({
    name: createName('vacancy', 'date', 'select'),
    goalId: 'vybor_daty_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор даты при создании объявления',
  }),

  VacancyTimeStartSelect: createEventFactory({
    name: createName('vacancy', 'time', 'start'),
    goalId: 'vybor_vremeni_nachala_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор времени начала при создании объявления',
  }),

  VacancyTimeEndSelect: createEventFactory({
    name: createName('vacancy', 'time', 'end'),
    goalId: 'vybor_vremeni_okonchaniya_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор времени окончания при создании объявления',
  }),

  VacancyAddressSelect: createEventFactory({
    name: createName('vacancy', 'address', 'select'),
    goalId: 'vybor_adresa_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор адреса при создании объявления',
  }),

  VacancyAgeSelect: createEventFactory({
    name: createName('vacancy', 'age', 'select'),
    goalId: 'vybor_vozrasta_rebenka_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор возраста ребенка при создании объявления',
  }),

  VacancyAddChildClick: createEventFactory({
    name: createName('vacancy', 'child', 'add'),
    goalId: 'nazhatie_knopki_dobavit_rebenka_pri_sozdanii_ob"yavleniya',
    goalName: 'Нажатие кнопки "Добавить ребенка" при создании объявления',
  }),

  VacancyChildWithDisabilities: createEventFactory({
    name: createName('vacancy', 'childWithDisabibities', 'select'),
    goalId: 'vybor_selektora_u_menya_est_osobyj_rebenok_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор селектора "У меня есть особый ребенок" при создании объявления',
  }),

  VacancyRegularSpecialist: createEventFactory({
    name: createName('vacancy', 'regular', 'select'),
    goalId: 'vybor_selektora_ishchu_postoyannuyu_nyanyu_pri_sozdanii_ob"yavleniya',
    goalName: 'Выбор селектора "Ищу постоянную няню" при создании объявления',
  }),
};
